module.exports = __webpack_public_path__ + "img/dinein.26a6d908.svg";